import { useEffect, useState, Fragment } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive';
import { FiMenu, FiX } from 'react-icons/fi';
import { Transition } from '@headlessui/react';

import Show from 'components/base/Show';
import classNames from 'utils/classNames';

const pages = [
  { name: '프로필', eng_name: 'Profile', path: '/' },
  // { name: '실험실', eng_name: 'LAB', path: '/labatory' },
  // { name: '게시판', eng_lab: 'Board', path: '/board' },
];

export default function Header() {
  const location = useLocation();
  const isWide = useMediaQuery({ query: '(min-width: 640px)' });

  const [path, setPath] = useState('/');
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    setPath(`/${location.pathname.split('/')[1]}`);
  }, [location.pathname]);

  useEffect(() => {
    if (isWide && isMobileMenuOpen) setIsMobileMenuOpen(false);
  }, [isWide]);

  return (
    <header className="sticky top-0 z-30 w-full border-b-2 bg-white">
      <nav className="content-xl flex items-end justify-between py-4">
        <Link to="/" className="w-56 font-logo text-4xl font-bold text-teal-500">
          NEWSEO.ME
        </Link>

        {/* PC 화면 */}
        {/* <Show show={isWide}>
          <ul className="flex gap-12 text-2xl font-bold text-gray-400">
            {pages.map(page => (
              <Link
                to={page.path}
                key={page.path}
                className={classNames(
                  path === page.path ? 'text-slate-800' : 'hover:text-gray-500',
                )}
              >
                {page.eng_name}
              </Link>
            ))}
          </ul>
        </Show>
        <div className="hidden w-56 min-w-[14rem] lg:block" /> */}

        {/* 모바일 화면 */}
        {/* <Show show={!isWide}>
          <button onClick={() => setIsMobileMenuOpen(true)}>
            <FiMenu className="text-4xl" />
          </button>

          <Transition
            show={isMobileMenuOpen}
            as="div"
            className="fixed left-0 top-0 flex h-screen w-screen"
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-x-40"
            enterTo="opacity-100 translate-x-0"
            leave="transition ease-in duration-200"
            leaveFrom="opacity-100 translate-x-0"
            leaveTo="opacity-0 translate-x-40"
          >
            <div className="flex-auto" onClick={() => setIsMobileMenuOpen(false)} />
            <div className="flex w-full max-w-[10rem] flex-col items-end gap-y-4 bg-teal-600 px-2 pt-4 sm:px-4">
              <button onClick={() => setIsMobileMenuOpen(false)}>
                <FiX className="text-4xl text-white" />
              </button>
              <div className="flex flex-col gap-y-4">
                {pages.map(page => (
                  <div className="relative text-2xl text-white" key={page.path}>
                    <Link to={page.path} onClick={() => setIsMobileMenuOpen(false)}>
                      {page.eng_name}
                    </Link>
                    <Show show={path === page.path}>
                      <div className="absolute -left-4 top-0 h-2 w-2 bg-white" />
                    </Show>
                  </div>
                ))}
              </div>
            </div>
          </Transition>
        </Show> */}
      </nav>
    </header>
  );
}
